// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"BrandingSection_formWrapper__3MPmj"};